import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
    private router = inject(Router);

    private history: string[] = [];
    private skipHistoryOnNextNavigation = false;

    constructor() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (!this.skipHistoryOnNextNavigation) {
                this.history.push(event.urlAfterRedirects);
            }
            this.setSkipHistoryOnNextNavigation(false);
        });
    }

    goBack(): void {
        this.router.navigateByUrl(this.getBackRoute());
        this.setSkipHistoryOnNextNavigation(true);
        this.history.pop();
    }

    getBackRoute(): string {
        return this.getPreviousUrl() ?? this.getFirstRouteFragment();
    }

    setSkipHistoryOnNextNavigation(skip: boolean): void {
        this.skipHistoryOnNextNavigation = skip;
    }

    getPreviousUrl(): string | null {
        return this.history.length > 1 ? (this.history[this.history.length - 2] ?? null) : null;
    }

    private getFirstRouteFragment(): string {
        const currentUrl = this.router.url;
        const pathSegments = currentUrl.split('/').filter(segment => segment.length > 0);

        if (pathSegments.length > 0) {
            return '/' + pathSegments[0];
        }

        return '/';
    }
}
